// Core
import styled from 'styled-components';

// Libraries
import { Button } from 'antd';

export const Element = styled.img`
  height: 200px;
  width: 50%;
  object-fit: contain;
  border-radius: 4px;
  box-sizing: border-box;
  position: relative;
`;

export const RemoveImage = styled(Button)`
  position: absolute;
  top: 12px;
  right: 12px;
  z-index: 1;
  visibility: hidden;
  color: ${({ theme }) => theme.color.imagePreview.removeIconColor};
    
  &:hover {
    color: ${({ theme }) => theme.color.imagePreview.removeIconHoverColor} !important;
  };
`;

export const ImageBlur = styled.div`
  height: 200px;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  background-color: transparent;
  z-index: 1;
  transition: all 0.4s ease-in-out;
  border-radius: 4px;
`;

export const ImageContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Container = styled.div`
  height: 100%;
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.color.imagePreview.borderColor};
  
  &:hover {
    ${RemoveImage} {
      visibility: visible;
    };

    ${ImageBlur} {
      background-color: ${({ theme }) => theme.color.imagePreview.imageBlurBackgroundColor};
      opacity: 0.5;
      backdrop-filter: blur(7px);
    };
  };
`;
